import { FormikProps } from "formik"
import React, { Dispatch } from "react"

import { CartItemDetailsType } from "@modules/tenants/OrdersPage/Components/AddOrderModal"
import { ValidateGiftcardCodeResponseType } from "@mono/essentials/types/CartTypes"
import { CustomerTypeOrder, PayOrderRequestType } from "@mono/essentials/types/OrderTypes"

import { PaymentAmountDetails } from "../PaymentModal"

import SquareCreditCardForm, { SquareCreditCardFormAttributes } from "./SquareCreditCardForm"

interface SquareCreditCardFormProps {
  handleClose: () => void
  onSuccess?: (paymentId: string, values: SquareCreditCardFormAttributes) => Promise<void> | void
  clientId: string
  locationId: string
  hideDefaultContainer?: boolean
  cartDetails?: CartItemDetailsType
  cartId?: string
  refetchCartData?: () => void
  paymentAmountDetails?: PaymentAmountDetails
  goToPrevStep?: () => void
  sqaureUpRef?: any
  squareUpFormRef?: React.RefObject<FormikProps<SquareCreditCardFormAttributes>>
  hideBackButton?: boolean
  payOrderTipDetails?: PayOrderRequestType["tip"]
  onlyTipPayment?: boolean
  isIntegratedPage?: boolean
  customer?: CustomerTypeOrder
  squarePaymentId: string
  hideSavedCards?: boolean
  giftcardDetails?: ValidateGiftcardCodeResponseType["giftcard"]
  isAuthUser?: boolean
  showPendingBookingPaymentConfirmation?: (arg0: boolean) => void
  handlePaymentConfirmation?: boolean
  isWidgetsCard?: boolean
}

const SquareCreditCard = ({
  handleClose,
  onSuccess,
  clientId,
  locationId,
  hideDefaultContainer = false,
  cartDetails,
  cartId,
  refetchCartData,
  goToPrevStep,
  paymentAmountDetails,
  sqaureUpRef,
  hideBackButton = false,
  payOrderTipDetails,
  onlyTipPayment = false,
  isIntegratedPage,
  customer,
  squarePaymentId,
  squareUpFormRef,
  hideSavedCards = false,
  giftcardDetails,
  isAuthUser = true,
  showPendingBookingPaymentConfirmation,
  handlePaymentConfirmation = false,
  isWidgetsCard = false,
}: SquareCreditCardFormProps) => {
  return (
    <SquareCreditCardForm
      onSuccess={onSuccess}
      handleClose={handleClose}
      clientId={clientId}
      locationId={locationId}
      hideDefaultContainer={hideDefaultContainer}
      cartDetails={cartDetails}
      cartId={cartId}
      refetchCartData={refetchCartData}
      paymentAmountDetails={paymentAmountDetails}
      goToPrevStep={goToPrevStep}
      sqaureUpRef={sqaureUpRef}
      squareUpFormRef={squareUpFormRef}
      hideBackButton={hideBackButton}
      payOrderTipDetails={payOrderTipDetails}
      onlyTipPayment={onlyTipPayment}
      isIntegratedPage={isIntegratedPage}
      customer={customer}
      squarePaymentId={squarePaymentId}
      hideSavedCards={hideSavedCards}
      giftcardDetails={giftcardDetails}
      isAuthUser={isAuthUser}
      showPendingBookingPaymentConfirmation={showPendingBookingPaymentConfirmation}
      handlePaymentConfirmation={handlePaymentConfirmation}
      isWidgetsCard={isWidgetsCard}
    />
  )
}

export default SquareCreditCard
